import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.cargohoraria.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.cargohoraria.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.cargohoraria.pesquisa(payload).then(res => {
        dispatch('ActionSetCategorias',res)
    }).catch(err => {
        dispatch('ActionSetCategorias',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.cargohoraria.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.cargohoraria.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.cargohoraria.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionNumero = ({dispatch},payload)=>{
    return serves.boletinstabela.numero(payload).then(res => {
        dispatch('ActionSetNumero',res)
    }).catch(err => {
        dispatch('ActionSetNumero',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetCategorias = ({commit},payload) =>{
    commit(types.SET_CATEGORIAS,payload)
}
export const ActionSetNumero = ({commit},payload) =>{
    commit(types.SET_NUMERO,payload)
}
